import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { handleChange, handleSubmit } from "../../controller/SageSetupController/CreateSageSetupController";
import SageSetupService from "../../controller/SageSetupController/SageSetupController";
import Loader from "../Loader";
import HelpSite from "../../../Common/HelpLink";
function SageSetup() {
  const { t } = useTranslation(); // Hook to access translations
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const { theme } = useContext(ThemeContext);
  const [DateFormatList, setDateFormatList] = useState([]);
  const HelpLink = localStorage.getItem('HelpLink');
  useEffect(() => {
    async function fetchSageSetup() {
      try {
        const redirectCallback = () => {
          navigate('/'); // Redirect to the login page
        };
        const sageSetup = await SageSetupService.GetAllSageSetup(redirectCallback);
        setFormData(sageSetup[0] || {}); // Initialize formData with the fetched data
      } catch (error) {
        console.error('Error fetching Roles:', error);
      }
    }
    fetchSageSetup();
  }, [navigate]);

  const handleFieldChange = (event) => {
    handleChange(event, formData, setFormData);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    try {
      const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
      };
      const redirectUserList = () => {
        navigate('/AdministrationSetting?saved=true'); // Redirect to the user list page
      };
      await handleSubmit(event, formData, setFormData, setErrors, redirectCallback, redirectUserList);
      const updatedSageSetup = await SageSetupService.GetAllSageSetup(redirectCallback);
      setFormData(updatedSageSetup[0] || {});
      window.scrollTo(0, 0);
    } catch (error) {
      setErrors({ submit: 'Submission failed. Please try again.' });
      console.error('Error submitting form:', error);
    }
  };

  return (
    <div>
      <form onSubmit={handleFormSubmit}>
        <div className="row mb-3">
          <div className="col-sm-12" style={{ "textAlign": "right" }}>
            <HelpSite FormName="Sage Setup" Module="26" />
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label htmlFor="ClientKey" className="col-sm-2 col-form-label">Client ID</label>
          <div className="col-sm-8">
            <input type="text" className="form-control" name="ClientKey" value={formData.ClientKey || ''} onChange={handleFieldChange} />
            {errors.ClientKey && <div style={{ color: 'red' }}>{errors.ClientKey}</div>}
          </div>
        </div>
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Client Secret</label>
          <div className="col-sm-8">
            <input type="text" className='form-control' name="ClientSecret" value={formData.ClientSecret} onChange={handleFieldChange} />
            {errors.ClientSecret && <div style={{ color: 'red' }}>{errors.ClientSecret}</div>}
          </div>
        </div>
        {/* Repeat similar structure for other fields */}
        <div className="row mb-3" style={{ "marginLeft": "0px" }}>
          <label for="inputText" className="col-sm-2 col-form-label">Subscription Key</label>
          <div className="col-sm-8">
            <input type="text" className='form-control' name="SubscriptionKey" value={formData.SubscriptionKey} onChange={handleFieldChange} />
            {errors.SubscriptionKey && <div style={{ color: 'red' }}>{errors.SubscriptionKey}</div>}


          </div>

        </div>






        <div className="row" style={{ "marginLeft": "0px", "float": "right" }}>
          <div className="col-sm-4">
            <button type="submit" className="btn btn-primary">
              <i className="icofont-save" aria-hidden="true"> Save

              </i>
            </button>

          </div>
        </div>
      </form>
    </div>
  );
}

export default SageSetup;
